import ServiceBase from './ServiceBase';

export default class CodingEventQueueService extends ServiceBase {
    async getQueues() {
        var result = await this.requestJson({
            url: "/api/admin/codingevent/queue",
            method: "GET"
        });

        return result;
    }

    async getQueue(id) {
        var result = await this.requestJson({
            url: `/api/admin/codingevent/queue/${id}`,
            method: "GET"
        });

        return result;
    }

    async saveQueue(queue) {
        var result = await this.requestJson({
            url: `/api/admin/codingevent/queue/`,
            method: "POST",
            data: queue
        });

        return result;
    }

    async addEditUser(user) {
        var result = await this.requestJson({
            url: `/api/admin/codingevent/queue/${user.codingEventQueueId}/member`,
            method: "POST",
            data: user
        });

        return result;
    }

    async removeUser(queueId, userId) {
    var result = await this.requestJson({
        url: `/api/admin/codingevent/queue/${queueId}/member/${userId}`,
        method: "DELETE"
    });

    return result;
}
}
